import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiTruck, FiEye } from 'react-icons/fi';

export default function OutdoorAreas() {
  return (
    <section id="freiflaechen" className="py-24 text-white bg-emerald-950">
      <div className="container px-4 mx-auto md:px-8">
        <div className="flex flex-col items-center mb-16 text-center">
          <h2 className="text-white section-title">Großzügige Freiflächen</h2>
          <p className="text-gray-300 section-subtitle">
            Neben den Hallen bietet das Gelände weitreichende Außenanlagen für Logistik, Präsentation und Parkmöglichkeiten.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-2">
          {/* Area 1 */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col bg-emerald-900/50 rounded-sm border border-emerald-800 overflow-hidden"
          >
            <div className="h-48 md:h-64 bg-gray-800 relative">
              <img 
                src="https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/b211e2c6acc399045347f7fa95bbdb6b.jpg" 
                alt="Ausstellungsfläche vor Halle C & A" 
                className="w-full h-full object-cover opacity-90" 
              />
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <SafeIcon icon={FiEye} className="text-2xl text-yellow-500" />
                <h3 className="text-2xl font-bold">Vor Halle C & A</h3>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> ca. 400 m² Ausstellungsfläche</li>
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> Direkt sichtbar von der Straße</li>
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> Hochgradig repräsentativ für Kunden</li>
              </ul>
            </div>
          </motion.div>

          {/* Area 2 */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex flex-col bg-emerald-900/50 rounded-sm border border-emerald-800 overflow-hidden"
          >
            <div className="h-48 md:h-64 bg-gray-800 relative">
              <img 
                src="https://media.wasacon.de/kueppers-gewerbeeinheiten/_assets/media/3a65b05dd439abaf21619c24e11cdb45.jpg" 
                alt="Logistikfläche hinter Halle E & F" 
                className="w-full h-full object-cover opacity-90" 
              />
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <SafeIcon icon={FiTruck} className="text-2xl text-yellow-500" />
                <h3 className="text-2xl font-bold">Hinter Halle E & F</h3>
              </div>
              <ul className="space-y-3 text-gray-300">
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> ca. 2.000 m² Logistikfläche</li>
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> Extrem stabiler Untergrund</li>
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> Punktfundamente (Kranaufstellung möglich)</li>
                <li className="flex gap-2"><span className="text-yellow-500">✓</span> 20 ausgewiesene Parkplätze</li>
              </ul>
            </div>
          </motion.div>
        </div>

        <div className="mt-16 text-center">
          <a href="#kontakt" className="btn-accent">Halle sichern</a>
        </div>
      </div>
    </section>
  );
}